<div class="container">
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="fs-27 m-5 text-color text-center">
        @if (!correlationId) {
        {{ isLoading && !isExpired ? 'Fetching your information, this will just take a moment...' : 'That magic link
        has expired or has already been used. Send me a new link to' }}

        @if (isExpired) {
        <a class="elink" (click)="signIn()">sign in</a>.
        }
        }

      </div>
    </div>
  </div>
</div>
@if (isExpired) {
<div class="boxTyp4 insertInFooter">
  <app-save-money-energy-bills></app-save-money-energy-bills>
</div>
}